import HubDashboard from './ConfigureCurb';
export default HubDashboard;
